
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ClientPortalBanner from './components/ClientPortalBanner';
import TestimonialsSection from './components/TestimonialsSection';
import BlogSection from './components/BlogSection';
import FeaturesSection from './components/FeaturesSection';
import CTASection from './components/CTASection';

const HOME_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#business`,
      "name": "Bold Plans Advisory",
      "description": "Expert tax preparation, tax planning, and financial advisory services in Jacksonville, Florida. IRS-compliant solutions for individuals and businesses.",
      "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
      "telephone": "+19043315669",
      "email": "boldplansadvisory@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Jacksonville",
        "addressRegion": "FL",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 30.3322,
        "longitude": -81.6557
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "16:00"
        }
      ],
      "priceRange": "$$",
      "areaServed": {
        "@type": "City",
        "name": "Jacksonville",
        "containedInPlace": {
          "@type": "State",
          "name": "Florida"
        }
      },
      "serviceType": ["Tax Preparation", "Tax Planning", "Tax Consulting", "Financial Advisory"],
      "sameAs": []
    },
    {
      "@type": "WebSite",
      "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`,
      "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
      "name": "Bold Plans Advisory",
      "publisher": {
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#business`
      }
    },
    {
      "@type": "WebPage",
      "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#webpage`,
      "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
      "name": "Bold Plans Advisory | Jacksonville FL Tax Preparation & Financial Advisory",
      "description": "Bold Plans Advisory offers expert tax preparation, tax planning, and financial advisory services in Jacksonville, Florida.",
      "isPartOf": { "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website` }
    }
  ]
};

const HomePage = () => {
  useEffect(() => {
    document.title = 'Bold Plans Advisory | Jacksonville FL Tax Preparation & Financial Advisory';
    let meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Bold Plans Advisory offers expert tax preparation, tax planning, and financial advisory services in Jacksonville, Florida. IRS-compliant solutions, secure client portal, and free tax liability calculator.');
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', (import.meta.env.VITE_SITE_URL || 'https://example.com') + '/');

    const scriptId = 'schema-home';
    let existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify(HOME_SCHEMA);
    document.head.appendChild(script);
    return () => { document.getElementById(scriptId)?.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <ClientPortalBanner />
        <TestimonialsSection />
        <BlogSection />
        <FeaturesSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
